﻿<script>
	import { registerPageComplete } from "../../tealium";
    import { onMount } from 'svelte';
    import model from '../../stores/modelStore';
    import { postalAddressConfirmOptions} from '../../config';
    import { projectSettings } from "../../config";
    import { formatDateTime, utcNow } from "../../helpers/dateHelpers";
    import { isValid } from "../../validation";

    import Checkbox from '../../components/Checkbox.svelte';
    import Select from '../../components/Select.svelte';
    import PageSection from '../../components/PageSection.svelte';
    import NavigationButtons from '../../components/NavigationButtons.svelte';
    import AlphaNumericInput from '../../components/AlphaNumericInput.svelte';
    import MaskedAlphaNumericInput from '../../components/MaskedAlphaNumericInput.svelte';
    import BSBInput from '../../components/BSBInput.svelte';
    import MaskedBSBInput from '../../components/MaskedBSBInput.svelte';
    import AccountNumberInput from '../../components/AccountNumberInput.svelte';
    import MaskedAccountNumberInput from '../../components/MaskedAccountNumberInput.svelte';
    import RadioGroup from '../../components/RadioGroup.svelte';
    import Address from '../../components/Address.svelte';

    import Form from "../../components/Form.svelte";
    import FormRow from "../../components/FormRow.svelte";
    import FormColumn from "../../components/FormColumn.svelte";

    
    export let pageName = null;
    export let pageTitle = null;
    export let lastVisitedPage = null;
	export let persistUrl = null;
    export let disabled = null;
    export let required = null;

    let buttons;
    let entrantIsShine = false;

    const australianAccount = "Australian account";
    const internationalAccount = "International account";
    

    if (!disabled) {
        $model.lastPageVisited = lastVisitedPage;
        document.title = pageTitle;
    }

    const accountTypeOptions = [
        { name: australianAccount },
        { name: internationalAccount },
    ];

    const shineCapacityOptions = [
        { name: "Authorised representative" },
        { name: "Claimant" },
        { name: "Legal Team" },
        { name: "NCT Team" },
    ];

    const capacityOptions = [
        { name: "Authorised representative" },
        { name: "Claimant" },
    ];

    const accountHolderFullNamePlaceholder = 'E.g. Mutu Ashenden';
    const accountNamePlaceholder = 'E.g. Tess Elizabeth Teoh or ABC Solutions Pty Ltd';

    

    const preSubmit = () => {
        $model.bankDetails.completedbyShine = false;
        $model.bankDetails.claimanatConfirmation = null;
        $model.bankDetails.claimantVerbalConfirmation = null;
        $model.bankDetails.claimantWrittenConfirmation = null;
        $model.bankDetails.dateWrittenConfirmationReceived = null;
        $model.bankDetails.dateWrittenConfirmationRequestSent = null;

        if (entrantIsShine){
            $model.bankDetails.completedbyShine = true;
            $model.bankDetails.claimantVerbalConfirmation = true;
            //$model.bankDetails.dateWrittenConfirmationRequestSent = formatDateTime(utcNow()); // moved Server side
        }
	}

    const handleSubmit = async () => {
		buttons.blockNext();
        
        // clean up
        cleanSelections();

		let errors = isValid();

		if (!errors.length) {

            preSubmit();
            
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(response);
			} else {
				registerPageComplete(
					pageName,
					$model.contact.emailAddress,
					$model.contact.phoneNumber,
				);
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const cleanSelections = () => {
	};

    onMount(() => {
		if ($model.entrant && $model.entrant.emailAddress){
            if ($model.entrant.emailAddress.toLowerCase().endsWith("@shine.com.au")){
                entrantIsShine = true;
            }
        }
	});
    

    //$:{
    //    console.log("bankDetails", $model);
    //}

</script>

<PageSection>
<Form id="form-bank-details" on:submit={handleSubmit}>
    <FormRow class="justify-content-center confirmation-hide">
		<FormColumn>
			<h4 class="text-center">{@html projectSettings.classActionName}</h4>
			<h1 class="text-center">Payment Details for Claimant</h1>
		</FormColumn>
	</FormRow>

    <FormRow>
        <FormColumn>
            <Checkbox id="noBankDetailsProvided" {disabled} bind:checked={$model.noBankDetailsProvided} label="I do not want to provide bank details at this time."></Checkbox>
        </FormColumn>
        <p>If you do not provide bank details, you will be posted a cheque to the postal address provided on this form.</p>
    </FormRow>

    <FormRow>
        <FormColumn>
            <p>Note: compensation payments will be made by electronic funds transfer if you provide bank details. If your bank details change, you need to tell us immediately.</p>
        </FormColumn>
    </FormRow>

    <div class="confirmation-box-shadow">
    {#if $model.noBankDetailsProvided}
        <h2>Postal Address</h2>
        <div class="form-row form-group">
            <div class="col-md-6">
                <label for="address" class:isrequired="{required}">Address entered on the Personal Details page</label>
                {#if ($model.claimant.postalAddress && $model.claimant.postalAddress.formattedAddress) }
                <input disabled required={true} type="text" bind:value="{$model.claimant.postalAddress.formattedAddress}" id="address" class="form-control" />
                {:else}
                <input disabled required={true} type="text" bind:value="{$model.claimant.address.formattedAddress}" id="address" class="form-control" />
                {/if}
            </div>
        </div>

        <FormRow>
            <FormColumn>
                <div class="form-row form-group">
                    <div class="col-md-6">
                        <RadioGroup required={true} {disabled}
                                name="addressConfirm"
                                bind:value="{$model.postalAddressConfirm}"
                                optionList={postalAddressConfirmOptions}
                            ></RadioGroup>
                    </div>
                </div>
            </FormColumn>
        </FormRow>

            {#if $model.postalAddressConfirm === 'I wish to provide a different postal address'}
                <FormRow>
                    <FormColumn>
                        <Address
                                addressPrefix='Postal'         
                                 bind:googlePlaceJson={$model.postalAddress.googlePlaceJson}
                                 bind:formattedAddress={$model.postalAddress.formattedAddress}
                                 bind:premise="{$model.postalAddress.premise}"
                                 bind:subpremise="{$model.postalAddress.subpremise}"
                                 bind:street="{$model.postalAddress.street}"
                                 bind:suburb="{$model.postalAddress.suburb}"
                                 bind:state="{$model.postalAddress.state}"
                                 bind:postcode="{$model.postalAddress.postcode}"
                                 bind:country="{$model.postalAddress.country}"
                                 bind:lat="{$model.postalAddress.lat}"
                                 bind:lng="{$model.postalAddress.lng}"
                                 bind:placeId="{$model.postalAddress.placeId}"
                                 bind:url="{$model.postalAddress.googleMapsUrl}"
                                 {disabled}
                                 required={true}
                                 >
                        </Address>
                    </FormColumn>
                </FormRow>
            {/if}
        <FormRow>
            <FormColumn>
            <div class="form-row form-group">
                <div class="col-md-6">
                    <Checkbox id="consentPaymentPosted" required={true} {disabled} bind:checked={$model.consentPaymentPosted} 
                        label="I consent to any compensation payments to be posted to the above"></Checkbox>
                </div>
            </div>
            </FormColumn>
        </FormRow>
    {:else}
        

        <div class="form-row form-group">
            <div class="col-md-6">
                <Select {required} {disabled} label="Account Type" id="accountType" bind:value="{$model.bankDetails.accountType}" optionList="{accountTypeOptions}" textProperty="name" valueProperty="name"></Select>
            </div>
        </div>

        <p>
        <b>
            <span style="color: #D83737; font-weight: 700;">IMPORTANT</span>
        </b>
        </p>
        <p>
        Please note the following:
        </p>
        <ul>
        <li>Any funds banked to your account by us will be subject to your bank's fee and clearance periods.</li>
        <li>We can only deposit funds into a bank, building society or credit union.</li>
        <li>We are unable to deposit into internet only accounts, e.g. high interest savings accounts, mortgage accounts, and term deposits, etc.</li>
        <li>If you are unsure if your account can receive funds from a third party please call your bank prior to completing this form.</li>
        </ul>

        {#if $model.bankDetails.accountType != internationalAccount }

        <div class="form-row form-group">
            <div class="col-md-6">
                <AlphaNumericInput required={true} {disabled} label="Bank name" id="au-bankName" maxlength="250" bind:value="{$model.bankDetails.bankName}" exceptions=" -'"></AlphaNumericInput>
            </div>
        </div>

        <div class="form-row form-group">
            <div class="col-md-6">
                <AlphaNumericInput required={true} {disabled} label="Account holder name" id="au-accountHolderName" maxlength="250" bind:value="{$model.bankDetails.accountHolderName}" exceptions=" -'" placeholder="{accountHolderFullNamePlaceholder}" alphaOnly></AlphaNumericInput>
            </div>
        </div>
        
        <div class="form-row form-group">
            <div class="col-md-6">
                <AlphaNumericInput required={true} {disabled} label="Account name" id="au-accounName" maxlength="250" bind:value="{$model.bankDetails.accountName}" exceptions=" -'" placeholder="{accountNamePlaceholder}" alphaOnly></AlphaNumericInput>
            </div>
        </div>

        <div class="form-row form-group">
            <div class="col-md-6">
                {#if disabled}
                    <MaskedBSBInput required={true} {disabled} label="BSB number" 
                        id="au-BSB" bind:value="{$model.bankDetails.bsb}"></MaskedBSBInput>
                {:else}
                    <BSBInput required={true} {disabled} label="BSB number" 
                        id="au-BSB" bind:value="{$model.bankDetails.bsb}"></BSBInput>
                {/if}
            </div>
        </div>

        <div class="form-row form-group">
            <div class="col-md-6">
                {#if disabled}
                    <MaskedAccountNumberInput required={true} {disabled} label="Account number" id="au-accountNumber" bind:value="{$model.bankDetails.accountNumber}"></MaskedAccountNumberInput>
                {:else}
                    <AccountNumberInput required={true} {disabled} label="Account number" id="au-accountNumber" bind:value="{$model.bankDetails.accountNumber}"></AccountNumberInput>
                {/if}
            </div>
        </div>

        <div class="form-row form-group">
            <div class="col-md-6">
                <AlphaNumericInput {disabled} label="Payment reference" id="au-paymentReference" maxlength="12" bind:value="{$model.bankDetails.paymentReference}" exceptions=" "></AlphaNumericInput>
            </div>
        </div>

    {/if}

    {#if $model.bankDetails.accountType == internationalAccount }

    <div class="form-row form-group">
        <div class="col-md-6">
            <AlphaNumericInput required={true} {disabled} label="Bank name" id="int-bankName" maxlength="250" bind:value="{$model.bankDetails.bankName}" exceptions=" -'"></AlphaNumericInput>
        </div>
    </div>

    <div class="form-row form-group">
        <div class="col-md-6">
            <AlphaNumericInput required={true} {disabled} label="Bank address" id="int-bankAddress" bind:value="{$model.bankDetails.bankAddress}" exceptions="() ,./-'"></AlphaNumericInput>
        </div>
    </div>
    
    <div class="form-row form-group">
        <div class="col-md-6">
            <AlphaNumericInput required={true} {disabled} label="Account holder's full name" id="int-accountHolderName" maxlength="250" bind:value="{$model.bankDetails.accountHolderName}" exceptions=" -'" placeholder="{accountHolderFullNamePlaceholder}" alphaOnly></AlphaNumericInput>
        </div>
    </div>

    <div class="form-row form-group">
        <div class="col-md-6">
            <AlphaNumericInput required={true} {disabled} label="Account holder's address" id="int-accountHolderAddress" maxlength="1000" bind:value="{$model.bankDetails.accountHolderAddress}" exceptions="() ,./-'"></AlphaNumericInput>
        </div>
    </div>

    <div class="form-row form-group">
        <div class="col-md-6">
            <AlphaNumericInput required={true} {disabled} label="Account holder's contact number" id="int-accountHolderContactNumber" maxlength="250" dataValidator="phone" bind:value="{$model.bankDetails.accountHolderContactNumber}" exceptions=" " numericOnly></AlphaNumericInput>
        </div>
    </div>
    
    <div class="form-row form-group">
        <div class="col-md-6">
            <AlphaNumericInput required={true} {disabled} label="Account name" id="int-accounName" maxlength="250" bind:value="{$model.bankDetails.accountName}" exceptions=" -'" placeholder="{accountNamePlaceholder}" alphaOnly></AlphaNumericInput>
        </div>
    </div>

    <div class="form-row form-group">
        <div class="col-md-6">
            {#if disabled}
                <MaskedAlphaNumericInput required={true} {disabled} label="SWIFT/BIC" id="int-SWIFT" dataValidator="swift" bind:value="{$model.bankDetails.swift}"></MaskedAlphaNumericInput>
            {:else}
                <AlphaNumericInput required={true} {disabled} label="SWIFT/BIC" id="int-SWIFT" dataValidator="swift" bind:value="{$model.bankDetails.swift}"></AlphaNumericInput>
            {/if}
        </div>
    </div>

    <div class="form-row form-group">
        <div class="col-md-6">
            {#if disabled}
                <MaskedAlphaNumericInput required={true} {disabled} label="International bank account number (IBAN)" id="int-IBAN" dataValidator="iban" bind:value="{$model.bankDetails.iban}"></MaskedAlphaNumericInput>
            {:else}
                <AlphaNumericInput required={true} {disabled} label="International bank account number (IBAN)" id="int-IBAN" dataValidator="iban" bind:value="{$model.bankDetails.iban}"></AlphaNumericInput>
            {/if}
        </div>
    </div>
    
    <div class="form-row form-group">
        <div class="col-md-6">
            <AlphaNumericInput {disabled} label="Payment reference" id="int-paymentReference" maxlength="12" bind:value="{$model.bankDetails.paymentReference}" exceptions=" "></AlphaNumericInput>
        </div>
    </div>

    {/if}

    <br>
    <h3>Authority and Release</h3>

    <div class="form-row form-group">
        <div class="col-md-6">
            <AlphaNumericInput required={true} {disabled} label="Name of person completing this form" id="submitterName" maxlength="250" bind:value="{$model.bankDetails.submitterName}" exceptions=" -'" alphaOnly></AlphaNumericInput>
        </div>
    </div>
        
    {#if entrantIsShine}
        <div class="form-row form-group">
            <div class="col-md-6">
                {#if disabled}
                <AlphaNumericInput required={true} {disabled} label="Capacity of person completing this form" id="submitterCapacity" maxlength="250" bind:value="{$model.bankDetails.submitterCapacity}"></AlphaNumericInput>
                {:else}
                <Select required={true} {disabled} label="Capacity of person completing this form" id="submitterCapacity" bind:value="{$model.bankDetails.submitterCapacity}" optionList="{shineCapacityOptions}" textProperty="name" valueProperty="name"></Select>
                {/if}
                
            </div>
        </div>
    {:else}
        <div class="form-row form-group">
            <div class="col-md-6">
                {#if disabled}
                <AlphaNumericInput required={true} {disabled} label="Capacity of person completing this form" id="submitterCapacity" maxlength="250" bind:value="{$model.bankDetails.submitterCapacity}"></AlphaNumericInput>
                {:else}
                <Select required={true} {disabled} label="Capacity of person completing this form" id="submitterCapacity" bind:value="{$model.bankDetails.submitterCapacity}" optionList="{capacityOptions}" textProperty="name" valueProperty="name"></Select>
                {/if}
            </div>
        </div>
    {/if}


    {#if entrantIsShine}
    {#if disabled && $model.bankDetails.claimantVerbalConfirmation == true && (($model.createdViaAdminPortal != null && $model.createdViaAdminPortal == false) || $model.createdViaAdminPortal == null)}
        <FormRow>
            <FormColumn>                
                <Checkbox {disabled} required="true" bind:checked="{$model.bankDetails.claimantVerbalConfirmation}" label="I confirm I have read the above details to the claimant who has verbally confirmed that these details are correct." id="claimantVerbalConfirmation"></Checkbox>             
            </FormColumn>
        </FormRow>
    {:else if !disabled}
        <FormRow>
            <FormColumn>
                <Checkbox required="true" bind:checked="{$model.bankDetails.claimantVerbalConfirmation}" label="I confirm I have read the above details to the claimant who has verbally confirmed that these details are correct." id="claimantVerbalConfirmation"></Checkbox>            
            </FormColumn>
        </FormRow>
    {/if}
    {/if}

    {#if disabled && $model.bankDetails.authorisedToComplete == true}
    <FormRow>
        <FormColumn>
            <Checkbox {disabled} required="true" bind:checked="{$model.bankDetails.authorisedToComplete}" label="I am the claimant, or am authorised to complete this form on behalf of the claimant." id="authorisedToComplete"></Checkbox>
        </FormColumn>
    </FormRow>
    {:else if !disabled}
    <FormRow>
        <FormColumn>
            <Checkbox required="true" bind:checked="{$model.bankDetails.authorisedToComplete}" label="I am the claimant, or am authorised to complete this form on behalf of the claimant." id="authorisedToComplete"></Checkbox>
        </FormColumn>
    </FormRow>
    {/if}

    {#if disabled && $model.bankDetails.confirmEft == true}
    <FormRow>
        <FormColumn>        
            <Checkbox {disabled} required="true" bind:checked="{$model.bankDetails.confirmEft}" label="I confirm that settlement distribution monies are to be deposited into the above bank account." id="confirmEft"></Checkbox>
        </FormColumn>
    </FormRow>
    {:else if !disabled}
    <FormRow>
        <FormColumn>        
            <Checkbox required="true" bind:checked="{$model.bankDetails.confirmEft}" label="I confirm that settlement distribution monies are to be deposited into the above bank account." id="confirmEft"></Checkbox>
        </FormColumn>
    </FormRow>
    {/if}
    {/if}

    </div>

    <FormRow class="confirmation-hide">
		<FormColumn>
			<NavigationButtons bind:buttons
				nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
		</FormColumn>
	</FormRow>
</Form>
</PageSection>

<style>
    .info-box {
        color: black;
        font-size: 12px;
        background-color: lightgray;
    }
</style>